import { TransactionsTable } from './TransactionsTable';

export const Transactions = () => {
  return <TransactionsTable testId="detailsTransactions" />;
};
